export default __webpack_public_path__ + "static/pattern-bg@2x-6e3a14672570f3fdb50d6a905ee90bee.webp";